import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const RefreshLeftSquareIcon = forwardRef<SVGSVGElement, IconProps>(function RefreshLeftSquareIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.02958 1.02958C1.7744 0.284763 2.88895 0 4.32558 0H7.67442C9.11105 0 10.2256 0.284763 10.9704 1.02958C11.7152 1.7744 12 2.88895 12 4.32558V7.67442C12 9.11105 11.7152 10.2256 10.9704 10.9704C10.2256 11.7152 9.11105 12 7.67442 12H4.32558C2.88895 12 1.7744 11.7152 1.02958 10.9704C0.284763 10.2256 0 9.11105 0 7.67442V4.32558C0 2.88895 0.284763 1.7744 1.02958 1.02958ZM1.62158 1.62158C1.11059 2.13257 0.837209 2.97152 0.837209 4.32558V7.67442C0.837209 9.02848 1.11059 9.86743 1.62158 10.3784C2.13257 10.8894 2.97152 11.1628 4.32558 11.1628H7.67442C9.02848 11.1628 9.86743 10.8894 10.3784 10.3784C10.8894 9.86743 11.1628 9.02848 11.1628 7.67442V4.32558C11.1628 2.97152 10.8894 2.13257 10.3784 1.62158C9.86743 1.11059 9.02848 0.837209 7.67442 0.837209H4.32558C2.97152 0.837209 2.13257 1.11059 1.62158 1.62158ZM5.87274 2.19009C6.04723 2.34175 6.06575 2.60615 5.91409 2.78064L5.77302 2.94297C5.84698 2.93828 5.92262 2.93582 6 2.93582C7.77165 2.93582 9.2093 4.37346 9.2093 6.14512C9.2093 7.91677 7.77165 9.35442 6 9.35442C4.22835 9.35442 2.7907 7.91677 2.7907 6.14512C2.7907 5.48425 2.99006 4.87417 3.32917 4.3623C3.45685 4.16957 3.7166 4.11684 3.90933 4.24452C4.10206 4.3722 4.15479 4.63195 4.02711 4.82468C3.77459 5.20584 3.62791 5.65622 3.62791 6.14512C3.62791 7.45439 4.69072 8.51721 6 8.51721C7.30928 8.51721 8.37209 7.45439 8.37209 6.14512C8.37209 4.83584 7.30928 3.77302 6 3.77302C5.88911 3.77302 5.78277 3.77962 5.68033 3.79166L6.00166 4.02686C6.18822 4.16341 6.22875 4.42534 6.0922 4.6119C5.95565 4.79845 5.69373 4.83899 5.50717 4.70244L4.42438 3.90988C4.32989 3.84072 4.26869 3.73514 4.25563 3.61877C4.24257 3.5024 4.27886 3.38588 4.35567 3.2975L5.28219 2.23145C5.43384 2.05695 5.69824 2.03844 5.87274 2.19009Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
